export default {
      id: "arrow-next-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow-next",
      toString: function () {
        return this.url;
      }
    }